/**
 * Generated by orval. Do not edit manually.
 */

export type FeedbackDeviceType = (typeof FeedbackDeviceType)[keyof typeof FeedbackDeviceType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedbackDeviceType = {
  desktop: 'desktop',
  mobile: 'mobile',
} as const
